const colors = require("../styles/colors");

module.exports = {
  pathPrefix: "/",
  siteTitle: "Pat Emery",
  siteLongTitle: "Pat Emery - Portfolio",
  siteUrl: "https://patemery.com",
  siteLanguage: "en",
  siteLogo: "",
  siteDescription: "Porfolio for my personal blog and projects",
  // manifest.json
  manifestName: "Pat Emery - Portfolio",
  manifestShortName: "pat-emery",
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.first,
  manifestThemeColor: colors.firstLight,
  manifestDisplay: "standalone",
  // analytics
  analyticsTrackingId: "UA-112535956",
  // author note
  authorName: "Pat Emery",
  authorDescription: `Software Developer `,
  // texts
  copyright:
    `2018`
};



// WEBPACK FOOTER //
// ./src/utils/siteConfig.js